var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-content" }, [
    _c("div", { staticClass: "c-bg" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-container" },
      [
        _c("TeamLeaderView", {
          attrs: { user: _vm.user },
          scopedSlots: _vm._u([
            {
              key: "leader-content",
              fn: function() {
                return [
                  !_vm.submitted
                    ? [
                        _c("div", { staticClass: "c-steps" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.slide.name) +
                              "\n\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "t-text" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.settings.description.subtitle) +
                              "\n\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.submit.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-input c-input--textarea" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "hmw-textarea" } },
                                  [_vm._v("Typ je antwoord")]
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.answer,
                                      expression: "answer"
                                    }
                                  ],
                                  attrs: { id: "hmw-textarea", rows: "10" },
                                  domProps: { value: _vm.answer },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.answer = $event.target.value
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--full c-button--main",
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.disabled
                                },
                                on: {
                                  keyup: function($event) {
                                    _vm.answer = $event.target.value
                                  }
                                }
                              },
                              [
                                _vm._v("\n\t\t\t\t\t\t\tVersturen "),
                                _c("svg", { staticClass: "icon icon_arrow" }, [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon_arrow" }
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    : [
                        _c("Waiting", {
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function() {
                                return [
                                  _c("h2", { staticClass: "t-title" }, [
                                    _vm._v("Gelukt!")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "t-text" }, [
                                    _c("p", [
                                      _vm._v("Jullie antwoord is verstuurd.")
                                    ])
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        })
                      ]
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }